var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkedin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.728,
    height: 39.728,
    viewBox: "0 0 39.728 39.728",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0072b1;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4436",
    "data-name": "Path 4436",
    className: "cls-1",
    d: "M36.89-31.687a2.727,2.727,0,0,1,2,.842,2.727,2.727,0,0,1,.842,2V5.2a2.727,2.727,0,0,1-.842,2,2.727,2.727,0,0,1-2,.842H2.838a2.727,2.727,0,0,1-2-.842A2.727,2.727,0,0,1,0,5.2V-28.85a2.727,2.727,0,0,1,.842-2,2.727,2.727,0,0,1,2-.842ZM11.971,2.365h.089V-16.612H6.119V2.365ZM9.045-19.184a3.328,3.328,0,0,0,2.439-1.02A3.278,3.278,0,0,0,12.5-22.6a3.278,3.278,0,0,0-1.02-2.394,3.328,3.328,0,0,0-2.439-1.02,3.184,3.184,0,0,0-2.394,1.02A3.352,3.352,0,0,0,5.675-22.6,3.352,3.352,0,0,0,6.651-20.2,3.184,3.184,0,0,0,9.045-19.184ZM34.052,2.365V-8.011q0-4.434-1.241-6.473-1.685-2.572-5.764-2.572a6.832,6.832,0,0,0-3.636.975,4.961,4.961,0,0,0-1.951,2.04h-.089v-2.572H15.7V2.365h5.853v-9.4a7.277,7.277,0,0,1,.621-3.37A3.127,3.127,0,0,1,25.1-11.912a2.541,2.541,0,0,1,2.66,1.685,9.4,9.4,0,0,1,.443,3.37V2.365Z",
    transform: "translate(0 31.688)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/linkedin.307e93d1fdb312f0f8204751f7a35986.svg";